import React from 'react'
import { IconType } from 'react-icons'

import './IconRow.scss'

const ICON_COLORS = {
  red: '#ff0000',
  blue: '2b78e4',
  green: '229e27',
}
export const IconRow: React.FC<{
  icon: IconType
  props?: any
  iconColor: keyof typeof ICON_COLORS
  text: string
  iconPadding?: number
}> = ({ icon, props = {}, text, iconColor, iconPadding }) => {
  return (
    <div className="icon-row">
      <div className="icon-row__icon">
        <div
          className="icon-row__icon__inner"
          style={{ padding: iconPadding ?? 22 }}
        >
          {React.createElement(icon, {
            ...props,
            color: ICON_COLORS[iconColor],
            size: '100%',
          })}
        </div>
      </div>
      <div
        className="icon-row__text"
        dangerouslySetInnerHTML={{ __html: text }}
      />
    </div>
  )
}
